// extracted by mini-css-extract-plugin
export var bodyContainer = "D3dZ2";
export var header = "V1ELJ";
export var paneContainer = "z4LhF";
export var paneContainerExpanded = "sYV3Y";